// A kiosk design belongs to one operation profile (equipment spec §6): it offers
// only that profile's services, and only its branches' kiosks may choose it.

import type { StoredLayout } from './api'
import type { Branch, OperationDoc, ProfileUnitKind, Service } from './types'

/** Every service any group of the profile routes. */
export function profileServiceIds(doc: Pick<OperationDoc, 'groups'>): Set<string> {
  const ids = new Set<string>()
  for (const g of doc.groups) for (const id of g.serviceIds) ids.add(id)
  return ids
}

/** The profile's active services, in catalogue order. */
export function servicesOfProfile(catalogue: readonly Service[], doc: Pick<OperationDoc, 'groups'>): Service[] {
  const ids = profileServiceIds(doc)
  return catalogue.filter((s) => s.active && ids.has(s.id))
}

/** The designs a unit of this kind may choose, screen and printed slip. */
export function designChoices(
  layouts: readonly StoredLayout[],
  kind: ProfileUnitKind,
  operationProfileId: string,
): { screen: StoredLayout[]; ticket: StoredLayout[] } {
  switch (kind) {
    case 'kiosk':
      return {
        screen: layouts.filter((l) => l.kind === 'kiosk' && l.operationProfileId === operationProfileId),
        ticket: layouts.filter((l) => l.kind === 'ticket'),
      }
    case 'display':
      return { screen: layouts.filter((l) => l.kind === 'display'), ticket: [] }
    case 'desk_display':
      return { screen: layouts.filter((l) => l.kind === 'counter'), ticket: [] }
    default:
      return { screen: [], ticket: [] }
  }
}

/** Branches whose published setup runs this profile (§11.1); a draft pointer does not count. */
export function profileBranches(branches: readonly Branch[], operationProfileId: string): Branch[] {
  return branches.filter((b) => b.operationProfileId === operationProfileId)
}
